(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('ParamTableauDialogController', ParamTableauDialogController);

    ParamTableauDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ParamTableau', 'ParamFormulaire'];

    function ParamTableauDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ParamTableau, ParamFormulaire) {
        var vm = this;

        vm.paramTableau = entity;
        vm.clear = clear;
        vm.save = save;
        vm.paramformulaires = ParamFormulaire.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paramTableau.id !== null) {
                ParamTableau.update(vm.paramTableau, onSaveSuccess, onSaveError);
            } else {
                ParamTableau.save(vm.paramTableau, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bhsApp:paramTableauUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
